// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/ec52a25c/" + chunkId + "." + __webpack_require__.h() + ".vec52a25c.js";
};